import { useResetPassword as useResetPasswordAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useParams } from "@tanstack/react-router"
import { useMemo } from "react"
import { noticeError } from "src/utils"

export function useResetPassword(baseURL?: string) {
  const resetPassword = useResetPasswordAPI(baseURL)

  const userId = useParams({
    from: "/public/users/$userId/password/edit",
    select: (s) => s.userId,
  })

  return useMemo(
    () => !resetPassword
      ? undefined
      : async (password: string) => {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get("token") ?? ""

        try {
          const response = await resetPassword({
            accountId: userId,
            password,
            token,
          })

          return response
        } catch (e) {
          noticeError(
            e,
            "ResetPassword",
          )

          throw e
        }
      },
    [
      userId,
      resetPassword,
    ],
  )
}
